import { useState } from "react";
import { Link, Navigate, Route, Routes } from "react-router-dom";
import { PageHead } from "../components/ui";
import { useFavorites } from "../favorites";
import { useMe } from "../session";
import { BalanceEvolutionReport, BalanceReport } from "./reports/Patrimony";
import { BudgetEvolutionReport, CategoryEvolutionReport, CategoryTotalsReport, CompareReport } from "./reports/Categories";
import { CashflowReport, EntriesReport } from "./reports/Cash";
import { GROUPS, REPORTS, type ReportGroup } from "./reports/catalog";

function Hub() {
  const { me } = useMe(); const realm = me.user.realm; const favs = useFavorites(realm);
  const [q, setQ] = useState(""); const [group, setGroup] = useState<ReportGroup | "todos">("todos");
  const norm = (s: string) => s.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();
  const shown = REPORTS.filter((r) => (group === "todos" || r.group === group) && (!q || norm(`${r.title} ${r.desc}`).includes(norm(q))));
  const to = (slug: string) => `/${realm}/relatorios/${slug}`;
  const card = (r: (typeof REPORTS)[number]) => {
    const g = GROUPS.find((x) => x.key === r.group)!; const fav = favs.has(to(r.slug));
    return (
      <div className="rep-card" key={r.slug} data-report={r.slug} style={{ borderTopColor: g.color }}>
        <Link to={r.slug} className="rep-card-link"><strong>{r.title}</strong><span className="muted small">{r.desc}</span></Link>
        <button type="button" className={`fav-star${fav ? " on" : ""}`} aria-pressed={fav} aria-label={fav ? "Remover dos favoritos" : "Favoritar"} title={fav ? "Remover dos favoritos" : "Favoritar (atalho na barra superior)"} onClick={() => favs.toggle(to(r.slug))}>{fav ? "★" : "☆"}</button>
      </div>);
  };
  const favReports = REPORTS.filter((r) => favs.has(to(r.slug)));
  return (
    <div className="page rep-page">
      <PageHead title="Relatórios" sub="Escolha um relatório. Marque com a estrela para criar um atalho na barra superior." />
      <div className="rep-controls">
        <input className="input" placeholder="Pesquisar relatório" value={q} onChange={(e) => setQ(e.target.value)} aria-label="Pesquisar relatório" data-rep-search />
        <div className="rep-chips">
          <button type="button" className={`chip-btn${group === "todos" ? " on" : ""}`} onClick={() => setGroup("todos")}>Todos</button>
          {GROUPS.map((g) => <button type="button" key={g.key} className={`chip-btn${group === g.key ? " on" : ""}`} onClick={() => setGroup(g.key)}><i className="dot" style={{ background: g.color }} /> {g.label}</button>)}
        </div>
      </div>
      {favReports.length > 0 && !q && group === "todos" && (<><h4>Favoritos</h4><div className="rep-grid">{favReports.map(card)}</div><hr style={{ margin: "18px 0" }} /></>)}
      <div className="rep-grid">{shown.map(card)}</div>
      {shown.length === 0 && <p className="muted">Nenhum relatório encontrado.</p>}
    </div>
  );
}

/** Módulo Relatórios: hub com cards e as telas de cada relatório. */
export function ReportsHub() {
  return (
    <Routes>
      <Route index element={<Hub />} />
      <Route path="balanco" element={<BalanceReport />} />
      <Route path="evolucao-bp" element={<BalanceEvolutionReport />} />
      <Route path="totais-categoria" element={<CategoryTotalsReport />} />
      <Route path="evolucao-categoria" element={<CategoryEvolutionReport />} />
      <Route path="metas-categorias" element={<BudgetEvolutionReport />} />
      <Route path="comparacao" element={<CompareReport />} />
      <Route path="fluxo-caixa" element={<CashflowReport />} />
      <Route path="lancamentos-caixa" element={<EntriesReport kind="caixa" />} />
      <Route path="a-pagar" element={<EntriesReport kind="pagar" />} />
      <Route path="a-receber" element={<EntriesReport kind="receber" />} />
      <Route path="pagas" element={<EntriesReport kind="pagas" />} />
      <Route path="recebidas" element={<EntriesReport kind="recebidas" />} />
      <Route path="por-categoria" element={<EntriesReport kind="categoria" />} />
      <Route path="*" element={<Navigate to="." replace />} />
    </Routes>
  );
}
